import { authApiService } from '@/api/authApiService';
import { ApiResponseType, Maybe, RequestOptions } from '@/types/sharedTypes';
import { ContractType } from '@/types/wireTypes';

export type CreateTransactionPayloadType = {
  name: string;
  expected_close_date: Maybe<string>;
};

export const createTransactionApi = (
  data: CreateTransactionPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<ContractType>> => {
  const uri = `/organization/contracts/`;

  return authApiService.POST(uri, data, null, options);
};
